import { render, staticRenderFns } from "./ModalFormScroll.vue?vue&type=template&id=273fd7d4&"
import script from "./ModalFormScroll.vue?vue&type=script&lang=js&"
export * from "./ModalFormScroll.vue?vue&type=script&lang=js&"
import style0 from "./ModalFormScroll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports